export default "__VITE_ASSET__B2h8j6dn__"